import { VideoHandlerInterface } from '../../../MediaController';
import { IVideoStreamController } from './types';

export abstract class MediaControllerController implements IVideoStreamController {
    abstract readonly type: string;
    #wrapperElement: HTMLDivElement;
    #handler: VideoHandlerInterface;

    constructor(wrapperElement: HTMLDivElement, handler: VideoHandlerInterface) {
        this.#wrapperElement = wrapperElement;
        this.#handler = handler;
    }

    canBePlayed(): Promise<boolean> {
        return Promise.resolve(true);
    }

    async getReadyForDisplay(): Promise<void> {
        await this.#handler.setElement(this.#wrapperElement);
    }

    async play(): Promise<void> {
        await this.#handler.play();
    }

    async pause(): Promise<void> {
        await this.#handler.stop();
    }

    async stop(): Promise<void> {
        await this.#handler.stop();
    }
}
